import { AccountingEvent } from '@shared/interfaces/accounting-event';
import { Observable } from 'rxjs';

export const ACCOUNTING_EVENT_REPOSITORY = 'AccountingEventsRepository';

export interface AccountingEventsRepository {
  getItems(): Observable<any>;

  add(accountingEvent: AccountingEvent): Observable<any>;

  edit(accountingEvent: AccountingEvent): Observable<any>;

  delete(item: any): Observable<any>;
}
